/** Runs the callback once the browser is idle, falling back to a short delay where there's no idle callback (Safari). Returns a cancel. */
export function whenIdle(callback: () => void): () => void {
  if ("requestIdleCallback" in window) {
    const id = window.requestIdleCallback(callback, { timeout: 5_000 });
    return () => window.cancelIdleCallback(id);
  }
  const id = setTimeout(callback, 1_000);
  return () => clearTimeout(id);
}
